<script>
import Cover from './Cover.vue'
export default {
    components: {
        Cover
    },
    props: {
        version: String,
        fullVersion: String,
        platform: String,
        fixed: Boolean,
        
    },
    data() {
        return {
            clickTimes: 0,
            showBonusScene: false,
            tabTitle: this.platform,
        }
    },
    computed: {
        displayVersion() {
            if (this.fixed) {
                return {
                    version: 'V 1.0',
                    fullVersion: 'V 1.0.0'
                }
            } else {
                return {
                    version: this.version,
                    fullVersion: this.fullVersion
                }
            }
        },
        platformStr() {
            if (this.platform) {
                return `视感知觉训练软件【${this.tabTitle}】`
            } else {
                return ''
            }
        },
    },
    methods: {
        click(clickTimes) {
            // console.log('when click', clickTimes)
            this.clickTimes = clickTimes
            if (this.clickTimes >= 5) {
                this.showBonusScene = true
            }
        },
        onChange(index) {
            if (index == 0) {
                this.tabTitle = this.platform || ''
            } else if (index == 1) {
                this.tabTitle = '注册信息'
            } else if (index === 2) {
                this.tabTitle = '标签'
            }
        },
    }
}
</script>

<template>
<AboutDialog :title="platformStr" @close="$emit('close')" :showBonusScene="showBonusScene" :selfLogo="false">
    <div class="container_box">
        <div class="content">
            <CarouselInfo fixed @onChange="onChange" @click="click" />
            <!-- <el-checkbox v-model="checked">以后不再显示</el-checkbox> -->
        </div>
    </div>

</AboutDialog>
</template>

<style lang="scss">
.alertAbout {
    .container_box {
        margin-bottom: 25px;
        height: 260px;

        .line {
            width: 309px;
            height: 2px;
            background-color: #EBEBEB;
        }
    }

    // .About {
    //     width: 500px;
    //     height: 300px;
    //     background: rgba(255, 255, 255, 1);
    //     border-radius: 12px;
    //     position: absolute;
    //     top: 50%;
    //     left: 50%;
    //     transform: translate(-50%, -50%);
    //     box-sizing: border-box;

    //     .title {
    //         font-size: 18px;
    //         font-weight: 400;
    //         color: #020202;
    //         line-height: 25px;
    //         margin-top: 15px;
    //         margin-bottom: 15px;
    //     }

    //     .line {
    //         width: 430px;
    //         height: 1px;
    //         background-color: #ebebeb;
    //         margin-bottom: 15px;
    //     }

    //     .text {
    //         >span {
    //             color: #646464;
    //             width: 90px;
    //             display: inline-block;
    //         }

    //         font-size:14px;
    //         font-weight:400;
    //         color:#00C1DE;
    //         line-height:20px;
    //     }

    //     .logo {
    //         position: absolute;
    //         top: 110px;
    //         right: 22px;
    //         z-index: 20;
    //     }

    //     .close {
    //         position: absolute;
    //         padding: 10px;
    //         top: 20px;
    //         right: 20px;
    //         cursor: pointer;
    //     }

    //     .box-card {
    //         height: 350px;

    //         .el-card__header {
    //             height: 77px;

    //             .clearfix {
    //                 margin-bottom: -10px;
    //             }
    //         }

    //         .el-carousel__container {
    //             height: 250px;

    //         }

    //         .el-carousel__indicator.is-active button {
    //             background-color: #00C1DE;
    //             height: 4px;
    //         }

    //         .el-carousel__indicator button {
    //             background-color: #A2A4A6;
    //             height: 4px;
    //         }
    //     }
    // }

    // .bonus_scene {
    //     width: 469px;
    //     height: 392px;
    //     background: rgba(255, 255, 255, 1);
    //     border-radius: 12px;
    //     position: absolute;
    //     top: 50%;
    //     left: 50%;
    //     transform: translate(-50%, -50%);
    //     box-sizing: border-box;

    //     .top {
    //         height: 302px;
    //         background-image: url('./assets/bonus_scene.png');

    //         .close {
    //             position: absolute;
    //             top: 20px;
    //             right: 20px;
    //             padding: 10px;
    //             // margin-bottom: 10px;
    //             cursor: pointer;
    //         }
    //     }

    //     .line {
    //         width: 430px;
    //         height: 1px;
    //         background-color: #ebebeb;
    //         margin-bottom: 15px;
    //     }

    //     .developer {
    //         height: 90px;

    //         .text {
    //             >span {
    //                 color: #646464;
    //                 width: 70px;
    //                 display: inline-block;
    //             }

    //             font-size:14px;
    //             font-weight:400;
    //             color:#646464;
    //             line-height:23px;
    //         }
    //     }
    // }

    // .slide-fade-enter-active {
    //     transition: all 1s ease;
    // }

    // .slide-fade-leave-active {
    //     transition: all 2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    // }

    // .slide-fade-enter,
    // .slide-fade-leave-to {
    //     transform: translate(-50%, 0);
    //     ;
    //     opacity: 0;
    // }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/About.vue